import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";
import { TmGifPickerComponent } from "../gifpicker/gif-picker.component";
import { TmEmojipickerComponent } from "../emojipicker/emoji-picker.component";
import { Emoji } from "../emojipicker/emoji.types";
import { Gif } from "../gifpicker/gif.types";

@Component({
    selector: "tm-mood-pickers",
    templateUrl: "./mood-pickers.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TmGifPickerComponent,
        TmEmojipickerComponent
    ]
})
export class TmMoodPickersComponent {

    @Output()
    protected onElement: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    addEmoji = (emoji: Emoji) => {
        this.onElement.next(emoji.unicode);
    }

    addGif = (gif: Gif) => {
        this.onElement.next(' ' + gif.url);
    }
}